import { call, put, takeEvery } from "redux-saga/effects";
import { leaderboardSlice } from "./leaderboardReducer";
import { notificationsSlice } from "../Notifications/notificationsReducer";
import {
    NOTIFICATION_MESSAGE_LEADERBOARD_EVENTS,
    NOTIFICATIONS_MESSAGE_TYPES
} from "../Notifications/notificationsConstants";
import { completeLeaderboardOnboardingSuccess } from "../../app/appActions";
import { getRequest, postRequest } from "../../app/request";
import { failurePut } from "../../app/failurePut";

function* joinToLeaderboardSaga() {
    try {
        yield call(postRequest,'/leaderboard/join' ,{});
    } catch (e) {
        yield call(failurePut, e, leaderboardSlice.actions.completeLeaderboardOnboardingError);
    }
}

function* completeLeaderboardOnboardingSaga() {
    yield put(notificationsSlice.actions.sendNotificationMessageAction({
        type: NOTIFICATIONS_MESSAGE_TYPES.LEADERBOARD,
        params: {
            event: NOTIFICATION_MESSAGE_LEADERBOARD_EVENTS.ONBOARDING_PASSED
        }
    }));

    yield put(completeLeaderboardOnboardingSuccess());
    yield call(joinToLeaderboardSaga);
}

function* getLeaderboardGroupByCurrentUser() {
    try {
        const resp = yield call(getRequest, '/leaderboard/current-group');
        yield put(leaderboardSlice.actions.getLeaderboardGroupByCurrentUserSuccess(resp));
    } catch(e) {
        yield call(failurePut, e, leaderboardSlice.actions.getLeaderboardGroupByCurrentUserError);
    }
}

function* getLeaderboardLeagues() {
    try {
        const resp = yield call(getRequest, '/leaderboard/leagues');
        yield put(leaderboardSlice.actions.getLeaderboardLeaguesSuccess(resp));
    } catch(e) {
        yield call(failurePut, e, leaderboardSlice.actions.getLeaderboardLeaguesError);
    }
}

export function* leaderboardSagas() {
    yield takeEvery(leaderboardSlice.actions.completeLeaderboardOnboardingAction, completeLeaderboardOnboardingSaga);
    yield takeEvery(leaderboardSlice.actions.getLeaderboardGroupByCurrentUserAction, getLeaderboardGroupByCurrentUser);
    yield takeEvery(leaderboardSlice.actions.getLeaderboardLeaguesAction, getLeaderboardLeagues);
}